/* ============================================================
   SAJ · CLIENT REVIEW FIXES 4 — "Website View Changes", mobile pass
   (client doc 13.08.2026). Loaded from snippets/saj-head.liquid after
   saj-fix3.js. Everything here is additive and idempotent — no template,
   section setting or uploaded asset is touched.
   ============================================================ */
(function () {
  'use strict';
  if (window.__sajFix4) return;
  window.__sajFix4 = true;

  var d = document, de = d.documentElement;
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function mx() { return de.classList.contains('saj-menaxi-page'); }

  /* ==========================================================
     1 · "7 Days / Easy Returns" comes off every page
     Badge and promise copy only. The Return & Replacement accordion and
     the policy page still carry the real terms — those are the store's
     stated policy, not marketing furniture.
     ========================================================== */
  var RET = /(^|\W)7\s*-?\s*days?\b[\s\S]{0,24}(return|polic)|easy\s*returns?|hassle[\s-]*free/i;
  var RET_SEL = '.tbar-i, .dr2-b, .igx-sp-tr li, .gal4-badges .gb, .a7-trow .a7-t,' +
                ' .pb-item, .igx-tr, .promise > div';
  function stripReturns() {
    $$(RET_SEL).forEach(function (el) {
      if (!RET.test(el.textContent || '')) return;
      // the promise ribbon separates items with a diamond — take it too
      var sib = el.nextElementSibling;
      if (sib && sib.classList.contains('pb-dia')) sib.remove();
      el.remove();
    });
  }

  /* ==========================================================
     7 · drawer rows did nothing when tapped
     `<summary class="dr2-i">` is styled `display:flex`. Safari drops the
     native disclosure behaviour as soon as `display` is changed, so on an
     iPhone the Customization / Gold / Diamonds / Bridal rows were dead.
     Drive the toggle ourselves, identically in every browser.
     ========================================================== */
  d.addEventListener('click', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('.saj-drawer2 summary.dr2-i') : null;
    if (!s) return;
    var det = s.parentNode;
    if (!det || det.tagName !== 'DETAILS') return;
    e.preventDefault();
    var open = det.open;
    $$('.saj-drawer2 details.dr2-d[open]').forEach(function (o) { if (o !== det) o.open = false; });
    det.open = !open;
  }, false);

  /* the WhatsApp bubble floats above the open drawer and eats taps along
     its edge — stand it down while the drawer or cart is open */
  function fabGuard() {
    var dr = d.getElementById('saj-drawer'), ct = d.getElementById('saj-cart');
    function sync() {
      var on = (dr && dr.classList.contains('open')) || (ct && ct.classList.contains('open'));
      de.classList.toggle('saj-drawer-open', !!on);
    }
    if (!fabGuard.obs && window.MutationObserver && (dr || ct)) {
      fabGuard.obs = new MutationObserver(sync);
      [dr, ct].forEach(function (el) {
        if (el) fabGuard.obs.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    }
    sync();
  }

  /* ==========================================================
     Shared · motif icons, taken from the theme's own sprite
     ========================================================== */
  var SPRITE = null;
  function sprite() {
    if (SPRITE !== null) return SPRITE;
    var u = d.querySelector('use[href*="saj-symbols"]');
    var h = u && u.getAttribute('href') || '';
    SPRITE = h ? h.split('#')[0] : '';
    return SPRITE;
  }
  function symbol(t) {
    t = (t || '').toLowerCase();
    if (/earring|jhumka|stud|mattal/.test(t)) return 'jhumka';
    if (/bangle|kada|bracelet|kappu/.test(t)) return 'banglem';
    if (/anklet/.test(t)) return 'peacock';
    if (/ring/.test(t)) return 'ringm';
    if (/chain|thali|mugappu|mangalyam|dollar/.test(t)) return 'thali';
    if (/diamond|solitaire/.test(t)) return 'diamondm';
    if (/idol|pooja|lamp|frame|coin|kumkum|chimil|pela/.test(t)) return 'lamp';
    if (/gift|scheme/.test(t)) return 'giftbox';
    if (/bridal|wedding|temple/.test(t)) return 'gopuram';
    if (/custom|personal/.test(t)) return 'mmwoman';
    return 'haram';
  }
  function icon(title, cls) {
    var s = sprite();
    if (!s) return '';
    return '<svg class="' + (cls || '') + '" viewBox="0 0 100 100" aria-hidden="true"><use href="' +
      s + '#' + symbol(title) + '"></use></svg>';
  }

  /* ==========================================================
     5 · catalogue grid at the top of the mobile menu
     The reference the client sent (CaratLane / GRT) opens on a tile grid,
     not a list.
     ========================================================== */
       /* ==========================================================
     Custom Gold + Silver categories for mobile drawer
     ========================================================== */
 var GOLD_CATEGORIES = [
  {
    title: 'Gold Bracelets',
    url: '/collections/bracelet',
    image: 'https://srianujewellers.com/cdn/shop/files/6_4c843a07-8ad2-44e5-9c94-71277f2dfbb4.jpg?v=1777467883&width=900'
  }
];

var SILVER_CATEGORIES = [
  {
    title: 'Mugappu Chain',
    url: '/collections/mugappu-chain',
    image: 'https://srianujewellers.com/cdn/shop/files/45-1_80122ec2-e256-425e-82b4-466d34756446.jpg?v=1765870731&width=1000'
  }
];


  function catalogueGrid() {
    var nav = d.querySelector('.saj-drawer2 .dr2-nav');
    if (!nav) return;
    // The menu's own top-level categories when they are real collection links
    // (Menaxi). The gold menu nests everything behind <details>, so there fall
    // back to the leaves of the "All Categories" panel — those read
    // unambiguously ("Gold Necklace", "Diamond Necklace"), which the silver
    // sub-styles ("Nagas", "Antique") would not.
    var links = $$(':scope > a.dr2-i', nav).filter(function (a) {
      return (a.getAttribute('href') || '').indexOf('/collections/') > -1;
    });
    if (links.length < 4) {
      var mega = d.querySelector('.saj-mega-cat .saj-mega-in');
      if (!mega) return;
      links = $$('.saj-mcol > a:not(.saj-mcol-all)', mega).filter(function (a) {
        return (a.getAttribute('href') || '').indexOf('/collections/') > -1;
      });
    }
    // links = links.slice(0, 16);
    // if (links.length < 4) return;

    // var key = links.map(function (a) { return a.textContent.trim(); }).join('|');
        // links = links.slice(0, 16);
        // links = links.slice(0, Math.max(0, 16 - CUSTOM_CATEGORIES.length));


    // var key = links.map(function (a) {
    //   return a.textContent.trim();
    // }).join('|') + '|' + CUSTOM_CATEGORIES.map(function (item) {
    //   return item.title + ':' + item.url;
    // }).join('|');
    var siteCategories = mx() ? SILVER_CATEGORIES : GOLD_CATEGORIES;

var key = links.map(function (a) {
  return a.textContent.trim();
}).join('|') + '|' + siteCategories.map(function (item) {
  return item.title + ':' + item.url;
}).join('|');


    var old = d.querySelector('.saj-drawer2 .saj-catwrap');
    if (old) { if (old.dataset.key === key) return; old.remove(); }

    var html = '<div class="saj-cathead">Shop by Category</div><div class="saj-catgrid">';
    // links.forEach(function (a) {
    //   var t = a.textContent.trim();
    //   var handle = (a.getAttribute('href') || '').split('/collections/')[1];
    //   html += '<a class="saj-cat" href="' + a.getAttribute('href') + '"><span class="ic">' +
    //     icon(t) + '</span><span class="tt">' + t + '</span></a>';
    // });
//     html += '<a class="saj-cat" href="' + a.getAttribute('href') + '">' +
//   '<span class="ic">' +
//     '<img data-collection="' + a.getAttribute('href') + '" alt="' + t + '">' +
//   '</span>' +
//   '<span class="tt">' + t + '</span>' +
// '</a>';
//     });

    /* Existing automatically detected categories */
    links.forEach(function (a) {
      var t = a.textContent.trim();

      html += '<a class="saj-cat" href="' + a.getAttribute('href') + '">' +
        '<span class="ic">' +
          '<img data-collection="' + a.getAttribute('href') + '" alt="' + t + '">' +
        '</span>' +
        '<span class="tt">' + t + '</span>' +
      '</a>';
    });

    /* Add site-specific custom category */
    var siteCategories = mx() ? SILVER_CATEGORIES : GOLD_CATEGORIES;

    siteCategories.forEach(function (item) {
      html += '<a class="saj-cat saj-custom-cat" href="' + item.url + '">' +
        '<span class="ic">' +
          '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
        '</span>' +
        '<span class="tt">' + item.title + '</span>' +
      '</a>';
    });

    /* Custom Gold + Silver categories */
    // CUSTOM_CATEGORIES.forEach(function (item) {
    //   html += '<a class="saj-cat" href="' + item.url + '">' +
    //     '<span class="ic">' +
    //       '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
    //     '</span>' +
    //     '<span class="tt">' + item.title + '</span>' +
    //   '</a>';
    // });

    html += '</div><a class="saj-catmore" href="/collections">View All Categories →</a>';

    var wrap = d.createElement('div');
    wrap.className = 'saj-catwrap';
    wrap.dataset.key = key;
    wrap.innerHTML = html;
    nav.parentNode.insertBefore(wrap, nav);

    // Load collection images
    wrap.querySelectorAll('img[data-collection]').forEach(function(img) {
      var url = img.getAttribute('data-collection');

      fetch(url)
        .then(function(res) {
          return res.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Try common Shopify collection image selectors
          var collectionImg =
            doc.querySelector('.collection-hero img') ||
            doc.querySelector('.collection-banner img') ||
            doc.querySelector('.banner img') ||
            doc.querySelector('main img');

          if (collectionImg) {
            img.src =
              collectionImg.src ||
              collectionImg.getAttribute('src') ||
              collectionImg.getAttribute('data-src');
          }
        })
        .catch(function(err) {
          console.log('Collection image error:', url, err);
        });
    });
  }

  /* ==========================================================
     8 · the Menaxi drawer wore the Sri Anu coat
     - the logo at the top read "Sri Anu Jewellers"
     - "Home" appeared twice (the drawer's own row plus the silver menu's)
     - every row carried the same diamond icon
     ========================================================== */
  function drawerIcons() {
    $$('.saj-drawer2 .dr2-nav .dr2-i').forEach(function (row) {
      var ic = row.querySelector('.ic');
      if (!ic || ic.dataset.sajIc) return;
      var label = (row.textContent || '').replace(/[›»]/g, '').trim();
      if (!label || /^home$|about|contact|scheme/i.test(label)) return;
      var svg = icon(label, 'saj-mxic');
      if (!svg) return;
      ic.innerHTML = svg;
      ic.dataset.sajIc = '1';
    });
  }

  // function menaxiDrawer() {
  //   if (!mx()) return;
  //   var logo = d.querySelector('.saj-drawer2 .dr2-logo');
  //   var alt = d.querySelector('.saj-header .saj-logo2 img');
  //   if (logo && alt && !logo.dataset.sajMx) {
  //     logo.dataset.sajMx = '1';
  //     logo.setAttribute('href', '/pages/menaxi');
  //     logo.setAttribute('aria-label', alt.getAttribute('alt') || 'Menaxi');
  //     logo.innerHTML = '<img src="' + alt.getAttribute('src') + '" alt="' +
  //       (alt.getAttribute('alt') || 'Menaxi') + '" height="30">';
  //   }
  //   // one Home row, pointing at the Menaxi landing
  //   var homes = $$('.saj-drawer2 .dr2-nav > a.dr2-i').filter(function (a) {
  //     return /^home$/i.test((a.textContent || '').trim());
  //   });
  //   if (homes.length > 1) {
  //     homes[0].setAttribute('href', '/pages/menaxi');
  //     homes.slice(1).forEach(function (a) { a.remove(); });
  //   }
  // }
function menaxiDrawer() {
  if (!mx()) return;

  window.__mxTopCategories = [];

  var logo = d.querySelector('.saj-drawer2 .dr2-logo');
  var alt = d.querySelector('.saj-header .saj-logo2 img');

  if (logo && alt && !logo.dataset.sajMx) {
    logo.dataset.sajMx = '1';
    logo.setAttribute('href', '/pages/menaxi');
    logo.setAttribute('aria-label', alt.getAttribute('alt') || 'Menaxi');

    logo.innerHTML =
      '<img src="' + alt.getAttribute('src') + '"' +
      ' alt="' + (alt.getAttribute('alt') || 'Menaxi') + '"' +
      ' height="30">';
  }

  var homes = $$('.saj-drawer2 .dr2-nav > a.dr2-i').filter(function (a) {
    return /^home$/i.test((a.textContent || '').trim());
  });

  if (homes.length) {
    homes[0].setAttribute('href', '/pages/menaxi');

    if (homes.length > 1) {
      homes.slice(1).forEach(function (a) {
        a.remove();
      });
    }
  }

  var nav = d.querySelector('.saj-drawer2 .dr2-nav');
  if (!nav) return;

  nav.querySelectorAll(':scope > a.dr2-i').forEach(function (link) {

    var title = (link.textContent || '').trim().toLowerCase();
    var cfg = MXC[title];

    if (!cfg) return;

    window.__mxTopCategories.push({
      title: link.textContent.trim(),
      href: cfg[0]
    });

    if (link.dataset.sajBuilt) return;

    link.dataset.sajBuilt = '1';

    var html =
      '<details class="dr2-d">' +
        '<summary class="dr2-i">' +
          link.innerHTML +
          '<span class="ch">›</span>' +
        '</summary>' +
        '<div class="dr2-sub">' +
          '<a href="' + cfg[0] + '">' +
            '<b>All ' + link.textContent.trim() + '</b>' +
          '</a>';

    [cfg[1], cfg[2]].forEach(function (group) {

      if (!group) return;

      group.split(';').forEach(function (item) {

        var p = item.split('|');

        if (p.length < 2) return;

        html +=
          '<a href="/collections/' + p[1] + '">' +
            p[0] +
          '</a>';

      });

    });

    html += '</div></details>';

    link.insertAdjacentHTML('beforebegin', html);

    link.style.display = 'none';
    link.dataset.sajOriginal = '1';
  });
}
  // function menaxiDrawer() {
  //   if (!mx()) return;

  //   /* Logo swap */
  //   var logo = d.querySelector('.saj-drawer2 .dr2-logo');
  //   var alt = d.querySelector('.saj-header .saj-logo2 img');

  //   if (logo && alt && !logo.dataset.sajMx) {
  //     logo.dataset.sajMx = '1';
  //     logo.setAttribute('href', '/pages/menaxi');
  //     logo.setAttribute('aria-label', alt.getAttribute('alt') || 'Menaxi');

  //     logo.innerHTML =
  //       '<img src="' + alt.getAttribute('src') + '"' +
  //       ' alt="' + (alt.getAttribute('alt') || 'Menaxi') + '"' +
  //       ' height="30">';
  //   }
  //   /* Fix Home link */
  //   var homes = $$('.saj-drawer2 .dr2-nav > a.dr2-i').filter(function (a) {
  //     return /^home$/i.test((a.textContent || '').trim());
  //   });
  //   if (homes.length) {
  //     homes[0].setAttribute('href', '/pages/menaxi');

  //     if (homes.length > 1) {
  //       homes.slice(1).forEach(function (a) {
  //         a.remove();
  //       });
  //     }
  //   }
  //   /* Build Minaxi drawer dropdowns */
  //   var nav = d.querySelector('.saj-drawer2 .dr2-nav');
  //   if (!nav) return;
  //   nav.querySelectorAll(':scope > a.dr2-i').forEach(function (link) {

  //     if (link.dataset.sajBuilt) return;

  //     var title = (link.textContent || '').trim().toLowerCase();
  //     var cfg = MXC[title];

  //     if (!cfg) return;

  //     link.dataset.sajBuilt = '1';

  //     var html =
  //       '<details class="dr2-d">' +
  //         '<summary class="dr2-i Hiiiiiiiiiii">' +
  //           link.innerHTML +
  //           '<span class="ch">›</span>' +
  //         '</summary>' +
  //         '<div class="dr2-sub">' +
  //           '<a href="' + cfg[0] + '">' +
  //             '<b>All ' + link.textContent.trim() + '</b>' +
  //           '</a>';

  //     [cfg[1], cfg[2]].forEach(function (group) {

  //       if (!group) return;

  //       group.split(';').forEach(function (item) {

  //         var p = item.split('|');

  //         if (p.length < 2) return;

  //         html +=
  //           '<a href="/collections/' + p[1] + '">' +
  //             p[0] +
  //           '</a>';

  //       });

  //     });

  //     html +=
  //         '</div>' +
  //       '</details>';

  //     link.insertAdjacentHTML('beforebegin', html);
  //     link.remove();

  //   });
  // }

  

  /* ==========================================================
     9 · Menaxi needed the same drop-down the gold side has,
         budget bands included
     The silver link list is flat, so the header has nothing to build a mega
     panel from. The panels are assembled here instead — sub-styles from the
     silver catalogue, plus a price band column driven by Shopify's own
     collection price filter (no new collections, nothing to keep in sync).
     'necklaces & harams': ['/collections/haram-and-necklaces',
     ========================================================== */
  var MXC = {
    'harams & necklaces': ['/collections/haram-and-necklaces',
      'Traditional|traditional-necklace;Nagas|deep-nagas-necklace;Antique|antique-necklace;Layered|layered-necklaces-trends',
      'Victorian|victorain-necklace;Swarovski|swarovski-necklace;Necklace Sets|necklace-sets;Silver Malai|silver-malai'],
    'earrings': ['/collections/statement-silver-earrings',
      'Nagas|nagas-earrings;Antique|antique-earrings;Traditional|traditional-earrings',
      'Kundan Stud|kundan-earrings;Swarovski|swarovski-earrings;Fancy|fancy-earrings'],
    'anklets': ['/collections/anklets',
      'Traditional|traditional-anklet;Antique|antique-anklets;Fancy|fancy-anklets',
      'Rose Gold|rose-gold-anklets;Baby Anklets|baby-anklets'],
    'bangles': ['/collections/bangles',
      'Nagas|nagas-bangles;Antique|antique-bangles;Precious Stone|precious-stone-bangles',
      'Baby Bangles|baby-bangles;Swarovski|swarovski-bangles;More Bangles|other-bangle-collections'],
    'chains': ['/collections/chains',
      'Silver Chains|chains;Mugappu Chain|mugappu-chain',
      'Dollar Chain|dollar-chain'],
    'bracelets': ['/collections/bracelet',
      'Bracelets|bracelet;Vel Kappu|vel-kappus',
      'Rings|rings;Nose Pin|silver-nose-pin'],
    'toe rings': ['/collections/toe-ring',
      'Toe Rings|toe-ring;Rings|rings',
      'Pendant|pendant;Silver Coin|silver-coin'],
    'signature collections' : [,
      'Bracelets|bracelet;Vel Kappu|vel-kappus;Nose Pin|silver-nose-pin',
      'Toe Rings|toe-ring;Rings|rings;Pendant|pendant;Silver Coin|silver-coin'
    ]
  };
  var BANDS = [
    ['Under ₹ 5,000', 'filter.v.price.lte=5000'],
    ['₹ 5,000 – ₹ 10,000', 'filter.v.price.gte=5000&filter.v.price.lte=10000'],
    ['₹ 10,000 – ₹ 25,000', 'filter.v.price.gte=10000&filter.v.price.lte=25000'],
    ['Above ₹ 25,000', 'filter.v.price.gte=25000']
  ];
  var HEADS = ['By Style', 'More to Explore'];

  function col(head, spec) {
    var out = '<div class="saj-mcol"><h6>' + head + '</h6>';
    spec.split(';').forEach(function (p) {
      var b = p.split('|');
      out += '<a href="/collections/' + b[1] + '">' + b[0] + '</a>';
    });
    return out + '</div>';
  }
  function megaHtml(cfg) {
    var h = '<div class="saj-mega saj-mega-mx" data-saj-mx="1"><div class="saj-mega-in">';
    h += col(HEADS[0], cfg[1]);
    h += col(HEADS[1], cfg[2]);
    h += '<div class="saj-mcol"><h6>Shop by Budget</h6><div class="saj-budget">';
    BANDS.forEach(function (b) {
      h += '<a href="' + cfg[0] + '?' + b[1] + '">' + b[0] + ' <span>→</span></a>';
    });
    h += '</div><a class="saj-mcol-all" href="' + cfg[0] + '">View All →</a></div>';
    return h + '</div></div>';
  }

  function menaxiMega() {
    if (!mx()) return;
    $$('.saj-header .saj-nav-row > li').forEach(function (li) {
      if (li.classList.contains('saj-allcat')) return;
      var a = li.querySelector(':scope > a');
      if (!a || li.querySelector('.saj-mega')) return;
      var cfg = MXC[(a.textContent || '').replace(/[▾›\s]+$/, '').trim().toLowerCase()];
      if (!cfg) return;
      li.insertAdjacentHTML('beforeend', megaHtml(cfg));
      if (!/▾/.test(a.textContent)) {
        a.insertAdjacentHTML('beforeend', ' <span style="font-size:9px;opacity:.6">▾</span>');
      }
    });
  }

  /* the "All Categories" panel still listed the gold catalogue on Menaxi */
  function menaxiAllCat() {
    if (!mx()) return;
    var inn = d.querySelector('.saj-mega-cat .saj-mega-in');
    if (!inn || inn.dataset.sajMx) return;
    var html = '';
    Object.keys(MXC).slice(0, 5).forEach(function (k) {
      var cfg = MXC[k];
      var title = k.replace(/\b\w/g, function (c) { return c.toUpperCase(); });

      var categoryImages = {
        'Earrings': 'https://srianujewellers.com/cdn/shop/files/14_a20ff020-befb-43ad-acca-e1b469fd64a2.jpg?v=1771069623&width=600',
        'Bangles': 'https://srianujewellers.com/cdn/shop/files/DSC09603.jpg?v=1783671716&width=600',
        'Rings': 'https://srianujewellers.com/cdn/shop/files/DSC09710.jpg?v=1783595217&width=1000',
        'Chains': 'https://srianujewellers.com/cdn/shop/files/DSC00163.jpg?v=1784177696&width=900',
        'Necklaces': 'https://srianujewellers.com/cdn/shop/files/14-1_ccfa428b-fd26-4aa2-b359-a6413833fa5c.jpg?v=1783315368&width=1000',
        'Anklets': 'https://srianujewellers.com/cdn/shop/files/DSC09282.jpg?v=1783409947&width=900'
      };

      var imageHtml = '';

      Object.keys(categoryImages).forEach(function(key) {
        if (title.toLowerCase().indexOf(key.toLowerCase()) !== -1) {
          imageHtml =
            '<img src="' + categoryImages[key] + '"' +
            ' alt="' + title + '"' +
            ' loading="lazy"' +
            ' width="60"' +
            ' height="60">';
        }
      });

      if (!imageHtml) {
        imageHtml = icon(title);
      }

      html += '<div class="saj-mcol">' +
        '<span class="saj-mcol-ic" aria-hidden="true">' +
        imageHtml +
        '</span>' +
        '<h6>' + title + '</h6>';

      // html += '<div class="saj-mcol"><span class="saj-mcol-ic" aria-hidden="true">' +
      //   icon(title) + '</span><h6>' + title + '</h6>';
      cfg[1].split(';').forEach(function (p) {
        var b = p.split('|');
        html += '<a href="/collections/' + b[1] + '">' + b[0] + '</a>';
      });
      html += '<a class="saj-mcol-all" href="' + cfg[0] + '">View All →</a></div>';
    });
    inn.dataset.sajMx = '1';
    inn.innerHTML = html;
  }

  /* ---------- run, and re-run when the theme (or saj-fixes.js) re-renders ---------- */
  function run() {
    stripReturns();
    fabGuard();
    menaxiAllCat();
    menaxiMega();
    menaxiDrawer();
    drawerIcons();
    catalogueGrid();
  }
  d.addEventListener('shopify:section:load', run);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
  // the Menaxi nav swap in saj-fixes.js and the pricing app both land late
  var row = d.querySelector('.saj-header .saj-nav-row');
  if (row && window.MutationObserver) {
    new MutationObserver(function () { run(); }).observe(row, { childList: true });
  }
  setTimeout(run, 900);
  setTimeout(run, 2600);
})();
